import axios from "axios";
import { APIURL } from "../configApi";
export const  axiosInstanceTemp = axios.create({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("temp_token")}`,
  },
});

// Request interceptors for API calls
 axiosInstanceTemp.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = `Bearer ${localStorage.getItem("temp_token")}`;
    return config;
  },
  (error) => {
    //console.log(error)
    //return Promise.reject(error);
    localStorage.clear();
    window.location.href(`${APIURL}/login`);
  }
);

// Add a response interceptor
 axiosInstanceTemp.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If the error status is 401 and there is no originalRequest._retry flag,
    // it means the token has expired and we need to refresh it
    if (error.response.status === 403  && !originalRequest._retry || error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("token");
        const response = await axios.post(`${APIURL}/global/auth/refresh`, {
          refreshToken,
        });
        const { access_token } = response.data;

        localStorage.setItem("token", access_token);

        // Retry the original request with the new token
        originalRequest.headers.Authorization = `Bearer ${access_token}`;
        return axios(originalRequest);
      } catch (error) {
        // Handle refresh token error or redirect to login
      }
    }

    return Promise.reject(error);
  }
);
